import moment from 'moment';
import React from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import axios from "axios";
import notification from '../../helpers/notification';

function EventCard({ event }) {
  const navigate = useNavigate();

  const handleReadMore = async (slug) => {
    if (event?.eventPdf) {
      try {
         const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/event/pdf/${slug}`, {
        responseType: 'blob',
        });

        const file = new Blob([res.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        window.open(fileURL, '_blank', 'noopener,noreferrer');

      } catch (err) {
        console.error(err);
        notification('error', 'Unable to open PDF');
      }
    } else {
      navigate(`/Event-Details/${slug}`);
    }
  };

  return (
    <div className="content-card">
      <div
        className="card-img-top bg-light d-flex justify-content-center align-items-center"
        style={{ height: '400px', overflow: 'hidden' }}
      >
        <img
          loading="lazy"
          src={`${process.env.REACT_APP_S3_URL}/uploads/event/${event?.image}`}
          alt={event?.title}
          style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
        />
      </div>

      <div className="content-info">
        <NavLink to={`/Event-Details/${event?.slug}`}>
          <h2>{event?.title}</h2>
        </NavLink>

        <h5>{moment(event.startDate).format('dddd, D MMMM YYYY')}</h5>

        <p>{event?.description?.substring(0, 200) + '...'}</p>

        <button
          onClick={() => handleReadMore(event?.slug)}
          className="custom-btn-cls box-hover my-4"
        >
          Read more
        </button>
      </div>
    </div>
  );
}

export default EventCard;